module.exports = __webpack_public_path__ + "img/bg.aa7b43aa.jpg";